import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import location_icon from "../../../assets/images/icon/location.svg";
import wind_season from "../../../assets/images/icon/wind_season.svg";
import wind_direction from "../../../assets/images/icon/wind_direction.svg";
import wind_sensor_link from "../../../assets/images/icon/wind_sensor.svg";
import suitable_sports from "../../../assets/images/icon/suitable_sports.svg";
import get_directions from "../../../assets/images/icon/get_directions.svg";
import GoogleMapView from "../GoogleMap/GoogleMapView";
import { Card } from "react-bootstrap";
import SpotAttribute from "./SpotAttribute";
import {
  Directions,
  GoogleMapConstants,
  spotConstants,
  translationConstants,
  viewPathConstants,
} from "../../../constants";
import { useSelector } from "react-redux";
import { getSportsAsAString } from "../../../container/views/Spots/utlilites";
import { useNavigate } from "react-router-dom";
import { googleLocationUrl } from "../../../system";
import StopPropagation from "../StopPropagation/StopPropagation";

function SpotAttributeWrapper(props) {
  const navigate = useNavigate();
  const [spotData, setSpotData] = useState(props.spotData);
  const [mapCenter, setMapCenter] = useState({
    lat: GoogleMapConstants.DEFAULT_LATITUDE,
    lng: GoogleMapConstants.DEFAULT_LONGITUDE,
  });
  const { t, i18n } = useTranslation();
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  let centerName, centerArabicName;
  const {
    name,
    arabicName,
    locationName,
    arabicLocationName,
    lat,
    long,
    usualWindDrection,
    preferredWindDrection,
    windSeason,
    nearWindSensorURL,
    windForecastURL,
    spotTypeId,
  } = props.spotData.spotInfo;
  getSportsAsAString(t, props.spotData.sportIds);
  if (props?.spotData?.centers?.length > 0) {
    ({ name: centerName, arabicName: centerArabicName } =
      props?.spotData?.centers[0]);
  }
  const cardContainerStyle = {
    height: "145px",
    width: "100%",
  };

  const cardMapOptions = {
    zoomControl: false,
    clickableIcons: false,
    disableDefaultUI: false,
  };

  const handleViewDetails = (centerId) => {
    navigate(viewPathConstants.VIEW_SPOT_DETAIL, {
      state: {
        centerId: centerId,
      },
    });
  };

  return (
    <div className="p-0">
      <div className="d-flex cast-shadow-on-hover borderRadius-15 col-md-12 mb-2">
        <div
          className={`${
            props?.spotData?.spotInfo?.spotTypeId ===
            spotConstants.spotType.PUBLIC
              ? "spot-type-head-public"
              : "spot-type-head-private"
          } px-1 text-center ${
            direction == Directions.ltr
              ? "right-border-radius"
              : "left-border-radius"
          }`}
        >
          <div
            className={`${
              direction == Directions.rtl ? "spot-type-head-text" : ""
            }`}
          >
            {props?.spotData?.spotInfo?.spotTypeId ===
            spotConstants.spotType.PUBLIC
              ? t(translationConstants.PUBLIC_SPOT)
              : t(translationConstants.PRIVATE_SPOT)}
          </div>
        </div>
        <div
          className={`${
            props.className
          } public-cards borderRadius-10  activity-card overflow-hidden w-100 ${
            direction == Directions.ltr
              ? "remove-borders-left"
              : "remove-borders-right"
          }`}
          onClick={() => handleViewDetails(props.spotData.id)}
        >
          <Card.Body className="row align-items-center">
            <section className="col-6 col-md-3 col-lg-2">
              <StopPropagation>
                <GoogleMapView
                  mapCenter={mapCenter}
                  locations={[
                    {
                      latitude: parseFloat(lat),
                      longitude: parseFloat(long),
                      isPublic: spotTypeId,
                    },
                  ]}
                  containerStyle={cardContainerStyle}
                  options={cardMapOptions}
                  zoom={4}
                />
              </StopPropagation>
            </section>
            <section className="col-6 col-md-9 col-lg-10 my-md-2 d-flex flex-column flex-md-row flex-lg-row justify-content-between my-0 px-3">
              <section className="d-flex col-12 col-md-3 col-lg-3 flex-column my-2 my-md-0 my-lg-0  flex-row justify-content-between">
                <section>
                  <h4 className="fw-bold font-18 m-0 m-md-auto text-ellipsis">
                    {direction === Directions.rtl && arabicName
                      ? arabicName
                      : name}
                  </h4>
                  {props?.spotData?.centers?.length > 0 && (
                    <h6 className="sub-heading-color font-14 m-0 m-md-auto">
                      {direction === Directions.rtl && centerArabicName
                        ? centerArabicName
                        : centerName}
                    </h6>
                  )}
                </section>
              </section>
              <section className="d-flex flex-column col-12 col-md-6 col-lg-6">
                <section className="d-flex my-md-0 my-lg-0">
                  <section id="location" className="m-0 m-md-auto col-12 col-md-6">
                    <SpotAttribute
                      icon={location_icon}
                      heading={t(translationConstants.LOCATION)}
                      label={
                        direction === Directions.rtl && arabicLocationName
                          ? arabicLocationName
                          : locationName
                      }
                      isHref={false}
                      leftToRight={!arabicLocationName }
                      isLabelHide={true}
                    />
                  </section>
                  {windSeason && (
                    <section id="wind-season" className="col-md-6 d-none d-md-block">
                      <SpotAttribute
                        icon={wind_season}
                        heading={t(translationConstants.WIND_SEASON)}
                        label={windSeason}
                        isHref={false}
                        isLabelHide={true}
                      />
                    </section>
                  )}
                </section>
                <section className="d-flex my-2 my-md-0 my-lg-0">
                  <section id="wind-direction" className=" pt-md-4 col-12 col-md-6">
                    <SpotAttribute
                      icon={wind_direction}
                      heading={t(translationConstants.WIND_DIRECTION)}
                      label={`${usualWindDrection}`}
                      isHref={false}
                      isLabelHide={true}
                    />
                  </section>
                  <section
                    id="suitable-sports"
                    className={`pt-4 col-6 d-none d-md-block`}
                  >
                    <SpotAttribute
                      icon={suitable_sports}
                      heading={t(translationConstants.SUITABLE_SPORTS)}
                      label={getSportsAsAString(t, props.spotData.sportIds)}
                      isHref={false}
                      isLabelHide={true}
                    />
                  </section>
                </section>
              </section>
              <div className="col-12 col-md-3 col-lg-2 flex-column my-2 my-md-0 my-lg-0 d-block d-md-flex justify-content-between mt-0 mt-md-auto">
                <div className="font-12 ms-auto center-card-view-detail-link approved-color d-flex justify-content-start">
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(`${googleLocationUrl(lat, long)}`, "_blank");
                    }}
                  >
                    <img
                      src={get_directions}
                      alt="get directions icon"
                      className="pe-1"
                    />
                    {t(translationConstants.GET_DIRECTIONS)}
                  </div>
                </div>
                <div
                  className="font-12 ms-auto center-card-view-detail-link approved-color spot-view-detail"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewDetails(props.spotData.id);
                  }}
                >
                  {t(translationConstants.VIEW_DETAILS)}
                </div>
              </div>
            </section>
          </Card.Body>
        </div>
      </div>
    </div>
  );
}

export default SpotAttributeWrapper;
